<template>
  <vnt-navview paneTitle="Budget">
    <vnt-navview-items>
      <vnt-navview-item icon="home">
        <router-link to="/">Start</router-link>
      </vnt-navview-item>
      <vnt-navview-item icon="tag">
        <router-link to="/categories">Categories</router-link>
      </vnt-navview-item>
      <vnt-navview-item icon="add">
        <router-link to="/item/add">Add item</router-link>
      </vnt-navview-item>
    </vnt-navview-items>
    <vnt-navview-content>
      <slot></slot>
    </vnt-navview-content>
    <vnt-navview-pane-footer>
      <vnt-navview-item icon="contact">{{ userName }}</vnt-navview-item>
    </vnt-navview-pane-footer>
  </vnt-navview>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AppShell',

  computed: mapState({
    userName: (state) => state.user.name,
    userId: (state) => state.user.uid
  })
}
</script>

<style>
a.router-link-exact-active {
  font-weight: 600;
}
</style>
